import React from "react";
import { useLang } from "../../context/lang-context";

const LandingCustomize: React.FC = () => {
  const { t } = useLang();

  return (
    <section className="showcase-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-10 col-md-5 text-center mb-4 mb-md-0">
            <img
              src="/img/iPhone-foo-screen-3@0.5x.png"
              alt={t("Personaliza ingredientes", "Customize ingredients")}
              className="showcase-phone"
            />
          </div>
          <div className="col-12 col-md-6 text-center text-md-start">
            <h2 className="showcase-title">
              {t("¿No te gusta algún ingrediente?", "Don't like an ingredient?")}
            </h2>
            <h3 className="showcase-subtitle">
              {t("Quítalo", "Remove it")}
            </h3>
            <p className="showcase-text">
              {t(
                "Escoge desde la app exactamente qué ingredientes quieres en tu pedido. Sin marcar, sin hablar, sin batallar.",
                "Pick from the app exactly what ingredients you want in your order. No dialing, no talking, no trouble."
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingCustomize;
